import { forwardRef, type InputHTMLAttributes } from 'react';
import { cn } from '../utils/styles';

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, label, error, id, ...props }, ref) => {
    return (
      <div className="flex flex-col gap-1">
        {label && (
          <label htmlFor={id} className="text-sm font-bold text-neutral-700">
            {label}
          </label>
        )}
        <input
          id={id}
          className={cn(
            'h-11 rounded-xl border-[0.5px] border-white/30 bg-white/40 backdrop-blur-[20px] px-3 text-base text-neutral-900 transition-all',
            'placeholder:text-neutral-400',
            'focus:bg-white/60 focus:border-primary-400/50 focus:outline-none focus:ring-2 focus:ring-[#3CB0DB]/20',
            'disabled:cursor-not-allowed disabled:bg-neutral-100/50 disabled:text-neutral-400',
            error && 'border-red-500 focus:border-red-500',
            className
          )}
          ref={ref}
          {...props}
        />
        {error && <p className="text-sm font-bold text-red-600">{error}</p>}
      </div>
    );
  }
);

Input.displayName = 'Input';
